import { useAuth } from '@skyslope/auth-react';
import { useQuery } from '@tanstack/react-query';

import type { IntegrationsResponse } from 'resources/server/IntegrationsServer';
import integrationsServer from 'resources/server/IntegrationsServer';

export const getIntegrationsQueryKey = 'get-integrations';

export function useGetIntegrations() {
  const { userContext } = useAuth();

  return useQuery<IntegrationsResponse>({
    queryKey: [getIntegrationsQueryKey],
    queryFn: () => {
      if (!userContext?.id) throw new Error('User ID is required');
      return integrationsServer.GetUserIntegrations(userContext.id);
    },
    enabled: !!userContext?.id,
  });
}
